import {
  getOffenseIcon,
  getFolderIcon,
  getSupportIcon,
  getItemIcon,
  getDisruptIcon,
  getSpeechIcon,
  getStolenItemIcon
} from './icon-folder'

//Get an icon based on the category
export function getIcon(categoryName, width) {

  if (categoryName === "offense") {
    return getOffenseIcon(width);
  }

  if (categoryName === "boosting" || categoryName === "healing") {
    return getSupportIcon(width);
  }


  if (categoryName === "cursing" || categoryName === "theft") {
    return getDisruptIcon(width);
  }


  if (categoryName === "item") {
    return getItemIcon(width);
  }

  if (categoryName === "stolen-item") {
    return getStolenItemIcon(width)
  }

  if (categoryName === "directory") {
    return getFolderIcon(width);
  }

  if (categoryName === "speech") {
    return getSpeechIcon(width);
  }

  return null
}


// WEBPACK FOOTER //
// ./src/battle/ArenaView/SubmissionMenu/icon-svg-getters/icon-categories.js